import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/**
 * The question you're probably asking as you look at this file is "Why aren't we loading the lazy-loaded
 * routes directly from @finders/finder?" The answer is twofold: 1) scopes do not work with the string
 * syntax required for `loadChildren`, which means loading them directly leads to ugly ../../ etc chaining.
 * 2) The generated output in dev mode does not lazy load the modules, preventing us from debugging them properly.
 * There is also a minor benefit, since angular's named chunks uses the folder/filename to generate the js filename,
 * leading to extremely long and hard to parse filenames if we load them directly.
 *
 * For more information on the way this works, please see this blog post I referenced:
 * https://medium.com/@tomastrajan/why-and-how-to-lazy-load-angular-libraries-a3bf1489fe24
 *
 */

const appRoutes: Routes = [
  {
    path: '',
    loadChildren: './landing/landing.module#LandingModule'
  },
  {
    path: 'results',
    loadChildren: './results/results.module#ResultsModule'
  },
  {
    path: 'join',
    loadChildren: './join/join.module#JoinModule'
  },
  {
    path: 'location',
    loadChildren: './location/location.module#LocationModule'
  },
  {
    path: 'sitemap',
    loadChildren: './sitemap/sitemap.module#SitemapModule'
  },
  // CatchAll Route
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
